import TopFilterSection from "../../components/Header/TopFilterSection";
import Hero from "../../components/Hero/Hero";
import ApproachSection from "../ApproachSection/ApproachSection";
import BagsCollection from "../Bags/BagsCollection";
import ShoesCollection from "../Shoes/ShoesCollection";

export default function Home() {
  return (
    <>
      {/* <Header /> */}
      <TopFilterSection />
      <Hero />
      <ShoesCollection />
      <BagsCollection />
      <ApproachSection />
      {/* <Footer /> */}
    </>
  );
}
